export enum SideNavigationTabType {
  TAB,
  SECTION
}
